<template lang="html">
  <div :class="content.type">
    <div class="form-inputs">
      <div class="form-input">
        <input type="text" class="form-control form-control-lg" name="form-fname" value="" placeholder="First Name" v-model="user.firstname" />
      </div>

      <div class="form-input">
        <input type="text" class="form-control form-control-lg" name="form-lname" value="" placeholder="Last Name" v-model="user.lastname" />
      </div>

      <div class="form-input">
        <input type="text" class="form-control form-control-lg" name="form-comp" value="" placeholder="Company Name" v-model="user.company" />
      </div>

      <div class="form-input">
        <input type="email" class="form-control form-control-lg" name="email" value="" placeholder="email@email.com" v-model="user.email" />
      </div>
    </div>

    <div class="actions">
      <button type="button" name="button" v-if="!checkForm()" class="disabled btn btn-outline-light btn-lg remix-next">Generate</button>
      <router-link v-if="abled" :to="{ name: 'report', params: { user: user }}" class="btn btn-outline-light btn-lg remix-next">Generate</router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, email } from 'vuelidate/lib/validators'
export default {
  props: [
    'content',
    'slug',
  ],
  data() {
    return {
      chosen: false,
      formValue: false,
      target: false,
      formKey: false,
      abled: false,
      ipData: false,
      user: {},
    }
  },
  validations: {
    user: {
      email: { required, email }
    }
  },
  methods: {
    buttonAble(abled) {
      return abled ? "" : "disabled";
    },
    setClass(i,c) {
      this.chosen = i;
      this.formValue = c.value;
      this.target = c.target;
      this.formKey = this.content.prop;
      this.abled = true;
      this.setFormVal({prop: this.formKey, value: this.formValue, group: this.content.group});
      this.$store.commit('setNext',this.nextQ);
    },
    getClass(i){
      return (i == this.chosen) ? 'chosen' : '';
    },
    getQ(slug) {
      return this.$store.state.content[slug].id;
    },
    setFormVal(payload){
      this.$store.commit('setFormData',payload);
    },
    checkForm(){
      let haveVal = true;
      const inputs = document.querySelectorAll('.button .form-input .form-control');
      // console.log(inputs);
      Array.from(inputs, (input) => {
        if ( !input.value ) {
          haveVal = false;
          return;
        }
      });
      if ( !this.$v.user.email.$invalid && haveVal ) {
        this.abled = true;
        return this.abled;
      } else {
        this.abled = false;
        return false;
      }
    }
  },
  computed: {
    nextQ() {
      let con = this.content;
      return this.chosen ? this.getQ(con.options[this.chosen - 1].target) : this.getQ(con.options[0].target);
    },
    targets() {
      let opt = this.content.options;
      let tar = [];
      opt.forEach(function(v){
        tar.push(v.target);
      });
      return Array.from(new Set(tar));
    }
  },
  created() {
    axios.get('https://ipapi.co/json/').then(response=>{
      this.ipData = response;
      this.user.ip = response.data.ip;
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars';
@import '../../assets/scss/mixins';

.button {
  width: rem-calc(242);
}

.btn.chosen {
  background:  $colTeal;
  color: white;
}

.form-inputs {
  margin-bottom: 1rem;
}

.form-input {
  // max-width: rem-calc(242);
  // width: 100%;

  &:not(:last-child) {
    margin-bottom: gu(0.5);
  }

  input {
    text-align: center;
    border: none;

    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      font-size: rem-calc(12);
      font-weight: $fwReg;
      color: #ED6024;

      @media only screen and (min-width: 40rem) {
        font-size: rem-calc(16);
      }
    }

    &::-moz-placeholder { /* Firefox 19+ */
      font-size: rem-calc(12);
      font-weight: $fwReg;
      color: #ED6024;

      @media only screen and (min-width: 40rem) {
        font-size: rem-calc(16);
      }
    }

    &:-ms-input-placeholder { /* IE 10+ */
      font-size: rem-calc(12);
      font-weight: $fwReg;
      color: #ED6024;

      @media only screen and (min-width: 40rem) {
        font-size: rem-calc(16);
      }
    }

    &:-moz-placeholder { /* Firefox 18- */
      font-size: rem-calc(12);
      font-weight: $fwReg;
      color: #ED6024;

      @media only screen and (min-width: 40rem) {
        font-size: rem-calc(16);
      }
    }

    &::placeholder {
      font-size: rem-calc(12);
      font-weight: $fwReg;
      color: #ED6024;

      @media only screen and (min-width: 40rem) {
        font-size: rem-calc(16);
      }
    }
  }
}
</style>
